import React from 'react';
var ThemeContext = React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}
export default ThemeContext;